import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useLocation } from 'react-router';

import { push } from 'connected-react-router';
import { selectAuthRoot } from '../../store/modules/auth/selectors';
import { setRouterPreviousPath } from '../../store/modules/app/actions';
import { selectCurrentUser } from '../../store/modules/users/selectors';
import Forbidden from '../forbidden/Forbidden';
import LoadingFrame from '../loading-frame/LoadingFrame';
import { DashboardRoute } from '../../routes/types';

type Props = DashboardRoute;

const ProtectedRoute = ({ guard, ...props }: Props) => {
  const user = useSelector(selectCurrentUser);

  const auth = useSelector(selectAuthRoot);

  const location = useLocation();

  const dispatch = useDispatch();

  useEffect(() => {
    if (!auth.tokens.access && !auth.loading) {
      dispatch(setRouterPreviousPath(`${location.pathname}${location.search}`));
      dispatch(push('/pages/login'));
    }
  }, [auth, location, dispatch]);

  if (user.loading || auth.loading) {
    return (
      <LoadingFrame />
    );
  }

  if (!guard || (user.data && guard(user.data))) {
    return <Route {...props} user={user.data} />;
  }

  return <Forbidden />;
};

export default ProtectedRoute;
